import { chartNames, rumEvents } from "../index";

const rumEventsByCharts = {
  [rumEvents.PERFORMANCE_NAVIGATION_EVENT]: [chartNames.PAGE_LOADS, chartNames.AVG_PAGE_LOAD_SPEED],
  [rumEvents.CONNECT_DEVICE]: [
    chartNames.CONNECTION_TIME,
    chartNames.IQOS_DEVICE_USAGE,
    chartNames.IQOS_DEVICE_CONNECTIONS_COUNT,
    chartNames.BROWSER,
    chartNames.OS
  ],
  [rumEvents.ADVANCED_DIAGNOSTIC_COMPLETED]: [
    chartNames.AD_STATISTICS,
    chartNames.DIAGNOSTICS_PERFORMANCE,
    chartNames.AD_COUNT
  ],
  [rumEvents.ADVANCED_DIAGNOSTIC_PROCESS]: [
    chartNames.AD_STATISTICS,
    chartNames.DIAGNOSTICS_ERRORS_READING_PERFOMANCE,
    chartNames.AD_STATISTICS,
    chartNames.DIAGNOSTICS_ERRORS_READING_PERFOMANCE
  ],
  [rumEvents.FIRMWARE_UPDATE]: [
    chartNames.FWU_STATISTICS,
    chartNames.FWU_PERFORMANCE,
    chartNames.FWU_ERRORS,
    chartNames.FWU_COUNT
  ],
  [rumEvents.FIRMWARE_UPDATE_DEVICE_RECONNECTION]: [chartNames.RECONNECTION_TIME_DURING_FWU],
  [rumEvents.SETTINGS]: [chartNames.SETTING_USAGE, chartNames.SETTING_PERFOMANCE],
  [rumEvents.BATTERY_HEALTH]: [
    chartNames.BATTERY_HEALTH_STATISTICS,
    chartNames.BATTERY_HEALTH_PERFORMANCE
  ]
};

export default rumEventsByCharts;
